<template>
  <b-modal id="modal-billing" title="Rekam Bukti Bayar" variant="success" ref="modalRespon" hide-footer
    no-close-on-backdrop no-close-on-esc>
    <loading :active.sync="this.$store.state.barpin.isLoading" :is-full-page="false"></loading>
    <form @submit.prevent="handleSubmit">
      <b-form-fieldset>
        <label for="">No. NTPN / Bukti Bayar</label>
        <b-form-input type="text" v-model="no_ntpn" required />
      </b-form-fieldset>
      <b-form-fieldset>
        <label for="">Tanggal NTPN / Bukti Bayar</label>
        <b-form-input type="date" v-model="tgl_ntpn" required></b-form-input>
      </b-form-fieldset>
      <b-form-fieldset>
        <b-form-file :plain="true" ref="file-input" @change="(e) => fileChanged(e, 'FILE_NTPN')" class="mb-2">
        </b-form-file>
        <span class="badge badge-secondary" v-if="!this.$store.state.barpin.files.FILE_NTPN">Belum
          Upload</span>
        <span class="badge badge-success" v-else>Sudah upload</span>
      </b-form-fieldset>

      <b-button class="pull-right" type="submit" variant="success">Simpan</b-button>
    </form>
  </b-modal>
</template>
<script>
import { mapActions } from 'vuex'
import swal from 'sweetalert'
export default {
  data () {
    return {
      no_ntpn: '',
      tgl_ntpn: '',
      file: {
        file: '',
        fileSize: '',
        fileExt: '',
        fileName: ''
      }
    }
  },
  methods: {
    ...mapActions({
      upload: 'barpin/setFile'
    }),
    async fileChanged (e, key) {
      // console.log(id)
      // this.$Progress.start()
      var fileReader = new FileReader()
      fileReader.readAsDataURL(e.target.files[0])
      this.file.fileSize = e.target.files[0].size / 1024
      this.file.fileExt = e.target.files[0].name.substr((e.target.files[0].name.lastIndexOf('.') + 1))
      this.file.fileName = e.target.files[0].name
      fileReader.onload = (e) => {
        this.file.file = e.target.result
        this.uploadFile(key)
        // this.$Progress.finish()
      }
    },
    uploadFile (key) {
      var data = {
        ...this.file,
        no_aju: this.$store.state.barpin.current_id_billing,
        key_file: key
      }
      this.upload(data).then(() => {
        swal('success', 'Berhasil meng-upload dokumen', 'success')
      }).catch((error) => {
        // swal('error', JSON.stringify(JSON.parse(error.bodyText).errors), 'error')
        swal('error', JSON.parse(error.bodyText.message), 'error')
      })
    },
    handleSubmit () {
      this.$store.commit('barpin/SET_LOADING', true)
      var data = {
        NO_NTPN: this.no_ntpn,
        TGL_NTPN: this.tgl_ntpn,
        id: this.$store.state.barpin.current_id_billing
      }
      this.$http.post('ppftz/billing', data).then(() => {
        this.$store.commit('barpin/SET_LOADING', false)
        swal('success', 'Berhasil Menyimpan', 'success').then(() => {
          this.$refs['my-modal'].hide()
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/views/ppftz/modal/ModalBilling.vue?08331860